import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { ReactSVG } from 'react-svg';
import { Icons } from '@/assets';
import modalStyles from '@/ctComponents/Modal/Modal.module.css';

const DURATION_MS = 1000;
const EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';

export default function ReceivablesHistoryOverlay({ open, onClose, children }) {
  const [mounted, setMounted] = useState(open);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (open) {
      setMounted(true);
      const id = requestAnimationFrame(() => {
        requestAnimationFrame(() => setVisible(true));
      });
      return () => cancelAnimationFrame(id);
    }
    setVisible(false);
    const t = window.setTimeout(() => setMounted(false), DURATION_MS);
    return () => window.clearTimeout(t);
  }, [open]);

  useEffect(() => {
    if (!mounted) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [mounted]);

  useEffect(() => {
    if (!mounted) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [mounted, onClose]);

  if (!mounted) return null;

  const overlayZ = 2147483000;
  const transition = `opacity ${DURATION_MS}ms ${EASE}, transform ${DURATION_MS}ms ${EASE}`;
  const backdropStyle = {
    position: 'fixed',
    inset: 0,
    zIndex: overlayZ,
    background: 'rgba(19, 21, 23, 0.4)',
    backdropFilter: 'blur(6px)',
    WebkitBackdropFilter: 'blur(6px)',
    cursor: 'default',
    opacity: visible ? 1 : 0,
    transition,
    pointerEvents: visible ? 'auto' : 'none',
  };

  return createPortal(
    <>
      <div role="presentation" style={backdropStyle} onClick={onClose} />
      <aside
        className="fixed top-0 right-0 bottom-0 flex min-h-0 flex-col rounded-l-[10px] border-none bg-white font-['Averta'] antialiased text-[#131517] shadow-2xl"
        style={{
          zIndex: overlayZ + 1,
          width: 'max(600px, min(60vw, 100vw))',
          maxWidth: '100vw',
          height: '100vh',
          minHeight: '100%',
          transform: visible ? 'translateX(0)' : 'translateX(100%)',
          transition,
        }}
        role="dialog"
        aria-modal="true"
      >
        <div className="flex min-h-0 flex-1 flex-col overflow-hidden px-5 pb-6 pt-4">
          {children}
        </div>
      </aside>
    </>,
    document.body
  );
}
